import React from 'react';
import { AutoComplete } from 'antd';
import { AutoCompleteProps } from '../../common/types';
import 'antd/dist/antd.css';
import '../../assets/css/autocomplete.css';

const AutoCompleteSearch: React.FC<AutoCompleteProps> = (Props) => (
  <AutoComplete
    style={{ width: '90%' }}
    options={Props.options}
    autoFocus={true}
    size="large"
    allowClear={true}
    placeholder={Props.placeholder}
    onSelect={(value: any, option: any) => {
      if (value) {
        Props.onClose();
      }
    }}
    filterOption={(inputValue: any, option: any) =>
      option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
    }
  />
);
export default AutoCompleteSearch;
